import { createStyles, Divider, List, ListItem, ListItemText, Theme, Typography, withStyles, WithStyles } from '@material-ui/core';
import dayjs from './RosterDayJS';
import memoize from 'memoize-one';
import React from 'react';
import { Shift } from './models/api';
import { Days } from './tablemodels';

interface ShiftDetailsProps {
    days: Days
}

interface Week {
  monday: Day,
  tuesday: Day,
  wednesday: Day,
  thursday: Day,
  friday: Day,
  saturday: Day,
  sunday: Day
}

interface Day {
  date: Date,
  shifts?: Shift[],
}

const styles = ({ palette }: Theme) =>
    createStyles({
    root: {
        width: '100%',
        backgroundColor: palette.background.paper,
      }
    })

interface ShiftDetailListItemProps {
  day: string,
  shifts?: Shift[],
}

const listItemStyles = createStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  }
})

class ShiftDetailListItem extends React.PureComponent<ShiftDetailListItemProps & WithStyles<typeof listItemStyles>> {
  render() {
    const { day, shifts, classes } = this.props;

    return (<ListItemText
      primary={day}
      secondary={ shifts && shifts.map((shift: Shift) => (
        <span key={`${shift.person}_${shift.start}`} className={classes.root}>
          <Typography
            component="span"
            variant="body2"
            color="textPrimary"
          >
            { shift.person }
          </Typography>
          {`${shift.start.substr(0, 5)}-${shift.end.substr(0, 5)}`}
        </span>
      ))}
    />);
  }
}

const StyledShiftDetailListItem = withStyles(listItemStyles)(ShiftDetailListItem);

class ShiftDetails extends React.PureComponent<ShiftDetailsProps & WithStyles<typeof styles>> {
  
  private readonly week = memoize((days: Days): Week | null => getWeek(days));

    render() {
        const { days, classes } = this.props;
        const week = this.week(days);

        return (<List className={classes.root}>
            <ListItem alignItems="flex-start">
              <StyledShiftDetailListItem day={"Monday"} shifts={week?.monday.shifts} />
            </ListItem>
            <Divider component="li" />
            <ListItem alignItems="flex-start">
              <StyledShiftDetailListItem day={"Tuesday"} shifts={week?.tuesday.shifts} />
            </ListItem>
            <Divider component="li" />
            <ListItem alignItems="flex-start">
              <StyledShiftDetailListItem day={"Wednesday"} shifts={week?.wednesday.shifts} />
            </ListItem>
            <Divider component="li" />
            <ListItem alignItems="flex-start">
              <StyledShiftDetailListItem day={"Thursday"} shifts={week?.thursday.shifts} />
            </ListItem>
            <Divider component="li" />
            <ListItem alignItems="flex-start">
              <StyledShiftDetailListItem day={"Friday"} shifts={week?.friday.shifts} />
            </ListItem>
            <Divider component="li" />
            <ListItem alignItems="flex-start">
              <StyledShiftDetailListItem day={"Saturday"} shifts={week?.saturday.shifts} />
            </ListItem>
            <Divider component="li" />
            <ListItem alignItems="flex-start">
              <StyledShiftDetailListItem day={"Sunday"} shifts={week?.sunday.shifts} />
            </ListItem>
          </List>);
    }
}

export default withStyles(styles)(ShiftDetails);

const getWeek = (days: Days): Week | null => {
  if (!days || days.size === 0) {
    return null;
  }
  
  const anyDay: Date = days.keys().next().value;
  const startOfWeek = dayjs(anyDay).startOf('isoWeek');
  const monday = startOfWeek.toDate(), 
    tuesday = startOfWeek.add(1, 'd').toDate(), 
    wednesday = startOfWeek.add(2, 'd').toDate(),
    thursday = startOfWeek.add(3, 'd').toDate(),
    friday = startOfWeek.add(4, 'd').toDate(),
    saturday = startOfWeek.add(5, 'd').toDate(),
    sunday = startOfWeek.add(6, 'd').toDate();

  return {
    monday: { date: monday, shifts: days.get(monday.getTime()) },
    tuesday: { date: tuesday, shifts: days.get(tuesday.getTime()) },
    wednesday: { date: wednesday, shifts: days.get(wednesday.getTime()) },
    thursday: { date: thursday, shifts: days.get(thursday.getTime()) },
    friday: { date: friday, shifts: days.get(friday.getTime()) },
    saturday: { date:saturday, shifts: days.get(saturday.getTime()) },
    sunday: { date: sunday, shifts: days.get(sunday.getTime()) },
  }
}